import { useState } from 'react';
import { Button, Group, Text } from '@mantine/core';
import { Language } from '../../languages/languageHandler';
import { useSelector } from 'react-redux';
import { AppState } from '../../client-redux/reducers';
import ModalComponent from '../modal';
import { IconX, IconCheck } from '@tabler/icons-react';
import './styles.scss';

interface DeleteConfirmationModalProps {
  action: () => void;
  message: string;
  successMessage: string;
  errorMessage: string;
  onReload?: () => void;
  showModal: boolean;
  closeModal: () => void;
}
const DeleteConfirmationModal = ({ action, message, showModal, closeModal }: DeleteConfirmationModalProps) => {
  const lang = useSelector<AppState, Language>(state => state.lang.lang);

  const [, /* loading */ setLoading] = useState<boolean>(false);

  const handleDelete = async () => {
    setLoading(true);
    try {
      action();
    } catch (error) {
    } finally {
      setLoading(false);
      closeModal();
    }
  };

  return (
    <>
      <ModalComponent
        show={showModal}
        handleClick={closeModal}
        classname="confirm-modal"
        content={
          <>
            <Text>{message}</Text>
            <Group className="buttons">
              <Button
                onClick={closeModal}
                className="no"
                radius="md"
                leftSection={<IconX style={{ cursor: 'pointer' }} stroke={2} />}
              >
                {lang.NO}
              </Button>
              <Button
                onClick={handleDelete}
                className="yes"
                radius="md"
                leftSection={<IconCheck style={{ cursor: 'pointer' }} stroke={2} />}
              >
                {lang.YES}
              </Button>
            </Group>
          </>
        }
      />
    </>
  );
};

export default DeleteConfirmationModal;
